// The two installable apps. Each has its own home-screen name, icon, scope and $297 AUD lifetime unlock.
export const APPS = {
  gates: {
    key: "gates",
    base: "/app",
    name: "13 Gates to Ecstasy",
    short: "13 Gates",
    manifest: "/gates-manifest.json",
    icon: "/gates-icon-192.png",
    touchIcon: "/gates-icon-180.png",
    bg: "#0A0706",
    owns: (u) => Boolean(u?.initiate),
    tagline: "The 13 Gates of the Orgasm Matrix",
    blurb: "Every Mastery Guide ritual from Root Resonance to Embodied Enlightenment, with Goddess Ariel, the Ankhing Breath, Daily Whispers and your practice journal.",
    includes: ["All 13 gates and their rituals", "Goddess Ariel, your guide by candlelight", "Daily Whispers and moon practices", "Your practice and intention journals"],
  },
  quantum: {
    key: "quantum",
    base: "/quantum",
    name: "Quantum Intimacy",
    short: "Quantum Intimacy",
    manifest: "/quantum-manifest.json",
    icon: "/quantum-icon-192.png",
    touchIcon: "/quantum-icon-180.png",
    bg: "#0B0509",
    owns: (u) => Boolean(u?.quantum),
    tagline: "Advanced Somatic & Quantum Intimacy",
    blurb: "Book II in full: Orgasmic Field Theory, fascial conductivity, remote field coupling, mirror-currents, the Triadic Gateways and Baseline Bliss, with Goddess Ariel beside you.",
    includes: ["All ten chapters and every protocol", "Solo and partnered field practices", "Goddess Ariel, guiding the field with you", "The Ankhing Breath and the full glossary"],
  },
};

export const PRICE = "$297 AUD";
export const BUNDLE = { key: "bundle", price: "$497", label: "$497 AUD", save: "$97" };
export const ownsNone = (u) => !APPS.gates.owns(u) && !APPS.quantum.owns(u);
